import axios from "axios";
import { ROOT_URL } from "../actions/constants";
import { IDeliveryFile } from "../models/IDeliveryFile";

export const uploadTaskFiles = async (studentTaskId: number, files: File[]): Promise<IDeliveryFile[]> => {
    const formData = new FormData();
    files.forEach(file => formData.append('Files', file));
    formData.append('StudentTaskId', studentTaskId.toString());
    const response = await axios.post(`${ROOT_URL}/UploadDeliveryFile`, formData, {
        headers: {
            Authorization: localStorage.getItem('id_token'),
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data as IDeliveryFile[];
}